import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList
} from '@angular/core';
import { Router } from '@angular/router';

import { NavPage } from './nav-page';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.html',
  host: {
    class: 'block h-full'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Navigation implements AfterContentInit {
  @Input() space: 'sm' | 'md' = 'md';
  @Input() event?: string | null;

  @Input()
  get navPageIndex(): number {
    return this._navPageIndex;
  }
  set navPageIndex(value: number | string) {
    if (typeof value === 'string') value = +value;
    if (!this.navPages) {
      this._navPageIndex = value;
      return;
    }

    value = Math.min(Math.max(value, 0), this.navPages.length - 1);

    const page = this.navPages.get(value);
    if (page) {
      if (this.activePages.includes(page)) {
        this.activePageIndex--;
        setTimeout(() => {
          this.activePages.pop();
          this.cdr.markForCheck();
        }, 150);
      } else {
        if (value > this._navPageIndex) {
          this.activePages.push(page);
          setTimeout(() => {
            this.activePageIndex++;
            this.cdr.markForCheck();
          });
        } else if (value < this._navPageIndex) {
          this.activePages[this.activePageIndex - 1] = page;
          setTimeout(() => {
            this.activePageIndex--;
            this.activePages.pop();
            this.cdr.markForCheck();
          });
        }
      }
    }

    this._navPageIndex = value;
    this.navPageIndexChange.emit(this._navPageIndex);
    this.cdr.markForCheck();
  }
  @Output() navPageIndexChange: EventEmitter<number> = new EventEmitter<number>();
  private _navPageIndex: number = 0;

  activePageIndex: number = 0;

  @ContentChildren(NavPage, { descendants: true }) navPages!: QueryList<NavPage>;

  get currentPage(): NavPage | undefined {
    return this.navPages.get(this._navPageIndex);
  }

  activePages: NavPage[] = [];

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterContentInit(): void {
    if (this.currentPage) {
      this.activePages = Array(this._navPageIndex).fill(null);
      this.activePages.push(this.currentPage);
      this.activePageIndex = this._navPageIndex;
    }
  }

  back(): void {
    // @ts-ignore
    if (this.event && window?.[this.event]) {
      // @ts-ignore
      window?.[this.event]?.postMessage('');
    }
    // @ts-ignore
    if (this.event && window?.flutter_inappwebview) {
      // @ts-ignore
      window?.flutter_inappwebview?.callHandler(this.event);
    }
    const navLink = this.navPages.get(this._navPageIndex)?.navLink;
    if (navLink) {
      this.router.navigateByUrl(navLink);
    } else if (this._navPageIndex > 0) {
      const page = this.activePages[this.activePageIndex - 1];
      const pageIndex = page ? this.navPages.toArray().indexOf(page) : this._navPageIndex - 1;
      this.navPageIndexChange.emit(pageIndex);
    }
  }
}
